<template>
  <div>
    <failed-payment-notification-bar/>
    <div class="account-settings">
      <subscription-settings/>
      <account-setting-button :title="'הוספת שותפ.ה למנוי'" :action="addMember"/>
      <account-setting-button :title="'הורדת התזרים לאקסל'" :action="downloadExcel" :icon="'fa-download'"
                              :icon-color="'green'" :loading="downloading"/>
      <account-setting-button :title="'סגירת חשבון ומחיקת פרטים'" :action="openChurnFlow" :color="'red'"/>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import router from '@/router';
import ChurnPopup from '@/pages/responsive-pages/authenticated/churn/ChurnPopup';
import AccountSettingButton
  from '@/pages/responsive-pages/authenticated/navigation-pages/account-settings/components/AccountSettingButton';
import cashflowHistory from '@/store/utilities/cashflow-history';
import cashflowToExcel from '@/store/utilities/cashflowForExcel';
import SubscriptionSettings from './SubscriptionSettings.vue';
import Segment from '../../../../../Segment';
import FailedPaymentNotificationBar from './components/FailedPaymentNotificationBar.vue';

export default {
  name: 'account-settings',
  components: {
    FailedPaymentNotificationBar,
    SubscriptionSettings,
    AccountSettingButton,
  },
  data() {
    return {
      downloading: false,
    };
  },
  async created() {
    Segment.trackUserGot('AccountSettingsEntered');
    this.startContentLoading(this.$options.name);
    this.doneContentLoading(this.$options.name);
  },
  methods: {
    ...mapActions('contentLoader', ['startContentLoading', 'doneContentLoading']),
    ...mapActions('modalRootStore', ['openModal']),
    addMember() {
      Segment.trackUserInteraction('InviteMemberClicked');
      router.push({ path: '/invite-member', query: this.$route.query });
    },
    openChurnFlow() {
      Segment.trackUserInteraction('ChurnButtonClicked');
      this.openModal({
        component: ChurnPopup,
      });
    },
    async downloadExcel() {
      Segment.trackUserInteraction('DownloadExcelClicked');
      this.downloading = true;
      const presentedBudgetDates = cashflowHistory.getYearBackBudgetDates();
      const budgets = await cashflowHistory.getBudgets(presentedBudgetDates);
      const cashflowsCsv = cashflowToExcel.convertToCsv(budgets);
      await this.saveCsv(cashflowsCsv);
      this.downloading = false;
    },
    async saveCsv(content) {
      const bom = '\uFEFF';
      const format = 'data:text/csv; charset=utf-8,';
      const a = document.createElement('a');
      a.setAttribute('href', format + bom + encodeURIComponent(bom + content));
      a.setAttribute('download', 'transactions.csv');
      a.click();
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../../scss/mixins';
  .account-settings {
    @include responsive-padding;
    padding-top: 17px;
    padding-bottom: 20px;
  }

</style>
